import { render, staticRenderFns } from "./Produktliste.vue?vue&type=template&id=11fc2692"
import script from "./Produktliste.vue?vue&type=script&lang=js"
export * from "./Produktliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports